/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.016 48a4.924 4.924 0 004.927-4.926H19.09A4.924 4.924 0 0024.016 48zm14.747-14.779V20.937c0-7.551-4.019-13.872-11.052-15.557V3.695C27.711 1.653 26.058 0 24.016 0s-3.695 1.685-3.695 3.727v1.686c-7.033 1.652-11.052 7.94-11.052 15.524v12.284l-4.926 4.926v2.463h39.314v-2.463z"/>'
}
